import React, {FC, useEffect, useRef} from "react"
import {FormMessageProps} from "./types"
import {FormMessageWrapper} from "@components/shared/FormMessage/styles"

const FomMessage: FC<FormMessageProps> = ({
                                              message,
                                              type,
                                              dense = false,
                                              useModalRoot = false,
                                              ...props
                                          }) => {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (ref?.current) {
            if (useModalRoot) {
                const scrollElement = document.querySelector("#modal-root > div")
                scrollElement?.scrollTo({
                    top: ref.current.getBoundingClientRect().top + scrollElement.scrollTop - 40,
                    behavior: "smooth"
                })
            } else {
                window.scrollTo({
                    top: ref.current.getBoundingClientRect().top + window.scrollY - 100,
                    behavior: "smooth"
                })
            }
        }
    }, [ref])

    return <FormMessageWrapper ref={ref} dense={dense} type={type} {...props}>
        {message}
    </FormMessageWrapper>
}

export default FomMessage
